import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { DataGrid, Icon, IconButton, Spacer, Stack, Tooltip, Typography } from '@emburse/embark-core';
import { CheckIcon, SyncIcon, UndoIcon } from '@emburse/embark-icons';
import dayjs from 'dayjs';
import ERPGatewayModal from '../../../../components/ERPGateway/components/ERPGatewayModal';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
import { useERPGatewayExport } from '../../../../components/ERPGateway/ERPGatewayExportProvider';
function ERPGatewayExportErrorsGridNoExpenses({ data, isActiveStatus, isSyncPending }) {
    useTranslation();
    const { setSelectedRows, getExpenseReportUrl, reSync, markAsExported, catchError } = useERPGatewayExport();
    const defaultModalProps = useMemo(() => ({
        onConfirm: () => { },
        onClose: () => { },
        open: false,
        header: 'Confirmation',
        body: _jsx("span", {}),
        confirmButtonText: 'OK',
        showCancel: false
    }), []);
    const [modalProps, setModalProps] = useState(defaultModalProps);
    const formatErrorsForModal = (errors) => {
        const parsedErrors = JSON.parse(errors);
        const formattedErrors = parsedErrors.Errors.map(({ code, message }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        _jsxs(Typography, { style: { marginBottom: '10px' }, children: [_jsx("strong", { children: code }), _jsx("br", {}), message] }, `${code}${index}`)));
        return formattedErrors;
    };
    const formatErrorsForGrid = (errors) => {
        const parsedErrors = JSON.parse(errors);
        const formattedErrors = parsedErrors.Errors.map(({ message }) => message);
        return formattedErrors.join(', ');
    };
    const viewErrorDetails = (errors) => {
        setModalProps({
            onConfirm: () => setModalProps(defaultModalProps),
            onClose: () => setModalProps(defaultModalProps),
            open: true,
            header: 'Expense Report Errors',
            body: formatErrorsForModal(errors),
            confirmButtonText: 'OK',
            showCancel: false
        });
    };
    const openUrl = async (id) => {
        try {
            const url = await getExpenseReportUrl(id);
            window.open(url, '_blank');
        }
        catch (error) {
            catchError(error);
        }
    };
    const onRowSelect = (selectionIds) => {
        setSelectedRows(selectionIds);
    };
    const columns = () => [
        {
            field: 'UserName',
            headerName: $t('User'),
            flex: 1,
            type: 'string'
        },
        {
            field: 'ReportName',
            headerName: $t('Report Name'),
            flex: 2,
            type: 'string'
        },
        {
            field: 'ApprovalCode',
            headerName: $t('Approval Code'),
            flex: 1,
            type: 'string'
        },
        {
            field: 'Date',
            headerName: $t('Date'),
            flex: 1,
            minWidth: 200,
            type: 'string',
            renderCell: (cell) => (_jsx(Typography, { variant: "body2", children: `${dayjs(cell.value)
                    .utc(true)
                    .local()
                    .tz(dayjs.tz.guess())
                    .format('ddd L LT')}` }))
        },
        {
            field: 'Error',
            headerName: $t('Error'),
            flex: 2,
            renderCell: (cell) => (_jsx(Typography, { variant: "body2", noWrap: true, style: { maxWidth: '215px', cursor: 'pointer' }, color: "primary", onClick: () => viewErrorDetails(cell.value), children: formatErrorsForGrid(cell.value) }))
        },
        {
            field: '',
            headerName: '',
            width: 135,
            renderCell: (cell) => (_jsxs(Stack, { direction: "row", spacing: 0, justifyContent: "space-between", children: [_jsx(Tooltip, { title: $t('Unprocess report. This will allow you to make changes to the report before attempting to re-export'), placement: "top", children: _jsx(IconButton, { color: "primary", disabled: !isActiveStatus || isSyncPending, onClick: () => openUrl(cell.row.id), children: _jsx(Icon, { iconUrl: UndoIcon }) }) }), _jsx(Tooltip, { title: $t('Re-export report. The report will be re-exported immediately'), placement: "top", children: _jsx(IconButton, { color: "primary", disabled: !isActiveStatus || isSyncPending, onClick: () => reSync(cell.row.id), children: _jsx(Icon, { iconUrl: SyncIcon }) }) }), _jsx(Tooltip, { title: $t('Mark as exported. The report will be excluded from future exports and will be removed from this queue'), placement: "top", children: _jsx(IconButton, { color: "primary", disabled: !isActiveStatus || isSyncPending, onClick: () => markAsExported(cell.row.id), children: _jsx(Icon, { iconUrl: CheckIcon }) }) })] }))
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(ERPGatewayModal, { ...modalProps }), _jsx(DataGrid, { columns: columns(), rows: data, allowSelection: true, disableRowSelectionOnClick: true, onRowSelectionModelChange: onRowSelect }), _jsx(Spacer, { size: 20 })] }));
}
export default ERPGatewayExportErrorsGridNoExpenses;
